import React, {Component} from 'react';
import { Modal } from 'reactstrap';
import { ClipLoader } from 'react-spinners';
import './loadingModal.css';

export default class LoadingModal extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                <Modal isOpen={this.props.visible}>
                        <div>
                            <ClipLoader
                                color={'#123abc'}
                                loading={this.props.visible}
                            />
                        </div>
                </Modal>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/loadingModal/loadingModal.js